<template>
  <div id="employee-detail">
    <CRow>
      <CCol :md="{ size: 8, offset: 2 }" class="employees-form">
        <div class="text-center">
          <h4 class="title-header">
            {{ $t("label.label_sabbatical_leave_infomation") }}
          </h4>
        </div>
        <div class="text-content">
          <label>{{ $t("employee.label_employee_code") }}</label>
          <div class="show-text">{{ sabbaticalLeaveRequest.employee_id }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_name") }}</label>
          <div class="show-text">
            {{
              sabbaticalLeaveRequest.employee
                ? sabbaticalLeaveRequest.employee.name
                : ""
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_position") }}</label>
          <div class="show-text">
            {{
              sabbaticalLeaveRequest.employee
                ? objectNotNull(sabbaticalLeaveRequest.employee.position)
                  ? sabbaticalLeaveRequest.employee.position.name
                  : ""
                : ""
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_division") }}</label>
          <div class="show-text">
            {{
              sabbaticalLeaveRequest.employee
                ? objectNotNull(sabbaticalLeaveRequest.employee.department)
                  ? sabbaticalLeaveRequest.employee.department.name
                  : ""
                : ""
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_created_at") }}</label>
          <div class="show-text">
            {{ sabbaticalLeaveRequest.updated_at | formatDate }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_date_start") }}</label>
          <div class="show-text">
            {{ sabbaticalLeaveRequest.start_time }}
            {{ sabbaticalLeaveRequest.start_date | formatDate }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_date_end") }}</label>
          <div class="show-text">
            {{ sabbaticalLeaveRequest.end_time }}
            {{ sabbaticalLeaveRequest.end_date | formatDate }}
          </div>
        </div>

        <div class="text-content">
          <label>{{
              $t("sabbatical-leave-request.label_number_days_leave")
            }}</label>
          <div class="show-text">
            {{ sabbaticalLeaveRequest.number_days_off }}
          </div>
        </div>

        <div class="text-content">
          <label>{{
              $t("sabbatical-leave-request.label_total_number_days_leaved")
            }}</label>
          <div class="show-text">
            {{ this.formatNumber(sabbaticalLeaveRequest.total_sabbatical_leaved) }}
          </div>
        </div>

        <div class="text-content">
          <label>{{
              $t("sabbatical-leave-request.label_number_day_leave_remain")
            }}</label>
          <div class="show-text">
            {{ sabbaticalLeaveRequest.total_remain_leave }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_reason") }}</label>
          <div class="show-text">
            {{
              $t(
                `commons.label_reason_sabbatical_leave_${sabbaticalLeaveRequest.reason_code}`
              )
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_sabbatical_leave_type") }}</label>
          <div class="show-text">
            {{
              $t(
                `commons.label_status_sabbatical_leave_type_${sabbaticalLeaveRequest.reason_type}`
              )
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.label_status") }}</label>
          <div class="show-text">
            {{
              $t(
                `commons.label_status_sabbatical_leave_request_${sabbaticalLeaveRequest.status}`
              )
            }}
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="8" sm="12" class="employees-form approval-ot">
        <div class="text-label">
          <div class="text-center">
            <h4 class="title-header">
              {{ $t("overtime.information_approval_ot") }}
            </h4>
          </div>
        </div>
        <div class="text-label-content">
          <div class="table-responsive table-employee-note">
            <table class="table">
              <thead>
              <tr>
                <th class="index">#</th>
                <th class="text-center create-by">
                  {{ $t("overtime.employee_approval") }}
                </th>
                <th class="text-center create-at">
                  {{ $t("overtime.employee_approval_status") }}
                </th>
                <th class="text-center">
                  {{ $t("overtime.employee_approval_note") }}
                </th>
                <th class="text-center">
                  {{ $t("overtime.employee_approval_time") }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(item,
                  index) in sabbaticalLeaveRequest.sabbatical_leave_approves"
                :key="index"
              >
                <th scope="row index">{{ index + 1 }}</th>
                <td>{{ item.employees[0].name }}</td>
                <td class="text-center create-at">
                  {{ $t(`overtime.employee_approval_${item.status}`) }}
                </td>
                <td class="text-center comment">{{ item.comment }}</td>
                <td class="text-center">
                  {{ item.updated_at | formatDate }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "Detail",
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_leave_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {};
  },
  created() {
    this.showSabbaticalLeaveRequest();
  },

  computed: {
    ...mapGetters({
      sabbaticalLeaveRequest: "sabbatical-leave-request/sabbaticalLeaveRequest"
    })
  },

  methods: {
    formatNumber(e) {
     if(Number(e) === e && e % 1 !== 0){
       return e.toFixed(2);
     }

      return e;
    },
    async showSabbaticalLeaveRequest() {
      let sabbaticalLeaveRequestId = this.$route.params.id;
      await this.$store.dispatch(
        "sabbatical-leave-request/detailSabbaticalLeaveRequest",
        sabbaticalLeaveRequestId
      );
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#employee-detail {
  padding: 20px 100px;

  .title-header {
    margin-bottom: 47px;
    border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }

  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;

    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 30px;

      .icon-text-label {
        margin-left: 8px;
      }
    }

    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .image {
        width: 70%;
      }

      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .text-area {
      height: 60px;
    }

    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }

  #toggle-btn {
    height: 37px;
  }

  .employees-form.approval-ot {
    margin: auto;

    .table-employee-note {
      background-color: white;
      margin-top: 20px;

      th {
        font-size: 15px;
      }

      td {
        color: #3c4b64;
      }

      td.comment {
        max-width: 300px;
        word-wrap: break-word;
      }
    }
  }
}

@media only screen and (max-device-width: 767px) {
  #employee-detail,
  #employee-detail .employees-form {
    padding: 0.3rem;
  }
  #employee-detail {
    .employees-form {
      .text-content {
        display: block;

        label {
          width: 100%;
        }
      }

      .show-text {
        width: 100%;
        border-radius: 3px;
      }
    }

    .title-header {
      margin-bottom: 2rem;
    }
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  #employee-detail {
    padding: 20px 0;

    .employees-form {
      padding: 0;
    }
  }
}
</style>
